import { Search, BarChart3, MapPin, FileText, LucideIcon } from "lucide-react"
import { Helmet } from 'react-helmet-async';
import LandingChrome from "src/components/search/LandingChrome"

const STEPS: { title: string; body: string; Icon: LucideIcon }[] = [
    {
        title: "1. Search any address",
        Icon: Search,
        body: "Type any Irish address or postcode into HomeIndex. We match it against our database of properties across the country and pinpoint the exact home you're interested in.",
    },
    {
        title: "2. We analyse local sales",
        Icon: BarChart3,
        body: "Our valuation engine looks at recent comparable sales nearby, adjusts for property size, condition and timing, and combines that with national market trends to estimate what the home is worth today.",
    },
    {
        title: "3. Explore the area",
        Icon: MapPin,
        body: "Every valuation comes with area insights — recent transactions, price trends, schools, transport and amenities — so you can understand the neighbourhood, not just the number.",
    },
    {
        title: "4. Decide with confidence",
        Icon: FileText,
        body: "Save valuations to revisit later, compare areas side-by-side, and use the data to negotiate, plan a sale, or just understand the market. HomeIndex is free to use for everyday searches.",
    },
]

export default function HowItWorksPageNext({ stateHandler, loginHelper, agentFinderUrl }: { stateHandler: any; loginHelper?: any; agentFinderUrl?: string }) {
    return (
        <LandingChrome stateHandler={stateHandler} loginHelper={loginHelper} agentFinderUrl={agentFinderUrl}>
            <Helmet>
                <title>How HomeIndex Works | Property Valuations in Ireland</title>
                <meta name="description" content="Learn how HomeIndex values Irish homes — real sales data, local area insights and market trends, all in one search." />
                <link rel="canonical" href="https://homeindex.ie/how-it-works" />
            </Helmet>

            <main className="landing-doc">
                <div className="landing-doc-inner">
                    <header className="landing-doc-header">
                        <span className="landing-doc-eyebrow">How it works</span>
                        <h1>From an address to an answer.</h1>
                        <p>HomeIndex turns Ireland's property sales data into a clear, honest estimate of what any home is worth — in seconds.</p>
                    </header>

                    <div className="landing-doc-grid">
                        {STEPS.map(({ title, body, Icon }) => (
                            <article className="landing-doc-card" key={title}>
                                <span className="landing-doc-card-icon" aria-hidden>
                                    <Icon size={24} strokeWidth={2} />
                                </span>
                                <div>
                                    <h2>{title}</h2>
                                    <p>{body}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </main>
        </LandingChrome>
    )
}
